import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';
import { createEnquirySchema } from '@/lib/forms/schemas/enquirySchema';

export const serviceEnquirySchema = createEnquirySchema({
  messageMin: 10,
  fullNameMin: 2,
  phoneMin: 7,
});

export type ServiceEnquiryValues = z.infer<typeof serviceEnquirySchema>;

export const serviceEnquiryDefaultValues: ServiceEnquiryValues = {
  fullName: '',
  email: '',
  phone: '',
  preferredContact: 'phone',
  message: '',
};

export const serviceEnquiryFields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full name',
    placeholder: 'Enter your full name',
    required: true,
    colSpan: 1,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email',
    placeholder: 'Enter your email',
    required: true,
    colSpan: 1,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone number',
    placeholder: 'Enter your phone number',
    required: true,
    colSpan: 1,
  },
  {
    name: 'preferredContact',
    type: 'radio',
    label: 'Preferred contact method',
    required: true,
    colSpan: 1,
    options: [
      { value: 'phone', label: 'Phone' },
      { value: 'email', label: 'Email' },
      { value: 'whatsapp', label: 'WhatsApp' },
    ],
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'How can we help?',
    placeholder: 'Tell us what you would like help with...',
    required: true,
    colSpan: 2,
    maxLength: 2000,
  },
];
